import React from 'react';
import {Route, Routes} from "react-router-dom";
import InstalledBaseScreen from './installedBase';
import InstalledBaseFileDownload from './installedBaseFileDownload';


const InstalledBaseRoutes = () => {
    return (
        <Routes>
            {/* Report notification deep link — must win over the tree splat,
                which would read "files/{fileId}" as node ids. */}
            <Route path=":nodeId/files/:fileId" element={<InstalledBaseFileDownload/>} />
            <Route path="*" element={<InstalledBaseScreen/>} />
        </Routes>
    );
}

export default InstalledBaseRoutes;
